import React from "react";
import videoBorder from "@assets/images/borders/video-border.webp";

const EpisodesSkeleton: React.FC = () => {
  return (
    <div className="relative h-[38rem] max-w-[490px] min-w-[330px]">
      <div className="skeleton relative w-full h-64 mb-2 !rounded-[2px_40px_30px_30px]">
        <img
          className="w-full h-full absolute top-0 left-0 -z-[1]"
          src={videoBorder}
          alt="video-border"
        />
      </div>
      <div className="w-full h-auto absolute -left-4 max-sm:left-0 !rounded-[2px_40px_30px_30px] p-8 flex flex-col gap-3">
        <img
          className="w-full h-full absolute top-0 left-0 -z-[1]"
          src={videoBorder}
          alt="video-border"
        />
        <div className="flex justify-between">
          <div className="skeleton w-36 min-h-6 !rounded-md"></div>
          <div className="skeleton w-8 min-h-6 !rounded-md"></div>
        </div>
        <div className="skeleton w-1/2 min-h-7 !rounded-md"></div>
        <div className="skeleton w-full min-h-7 !rounded-md"></div>
        <div className="flex gap-2 flex-col">
          <div className="skeleton w-full min-h-5 !rounded-md"></div>
          <div className="skeleton w-full min-h-5 !rounded-md"></div>
          <div className="skeleton w-full min-h-5 !rounded-md"></div>
        </div>
        <img
          className="w-full h-full absolute top-0 left-0 z-[1]"
          src={videoBorder}
          alt="video-border"
        />
        <div className="skeleton w-40 min-h-12 !rounded-full mt-10"></div>
      </div>
    </div>
  );
};

export default EpisodesSkeleton;
